import script from "./PrimaryButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&setup=true"

import "./PrimaryButton.vue?vue&type=style&index=0&id=29c0efa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c0efa0"]])

export default __exports__